// extracted by mini-css-extract-plugin
export default {"Page404":"_404_Page404__Q2tsE","homeImage":"_404_homeImage__qR7WB","MainText":"_404_MainText__PNOjO"};